export class AtlasProjects {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "projects",
            "baseName": "projects",
            "type": "Array<AtlasProject>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AtlasProjects.attributeTypeMap;
    }
    constructor() {
    }
}
